import { lazy } from "react";

export const routeNames = {
  home: { name: "Home", path: "/" },
  index: { name: "Index", path: "/Home" },
  aboutUs: { name: "AboutUs", path: "/AboutUs" },
  howItWorks: { name: "HowItWorks", path: "/HowItWorks" },
  plans: { name: "Plans", path: "/Plans" },
  blog: { name: "Blog", path: "/Blog" },
  partners: { name: "Partners", path: "/Partners" },
  testimonials: { name: "Testimonials", path: "/Testimonials" },
  createTestimonial: { name: "CreateTestimonial", path: "/CreateTestimonial" },
  privacyPolicy: { name: "PrivacyPolicy", path: "/PrivacyPolicy" },
  terms: { name: "Terms", path: "/Terms" },
  contactUs: { name: "ContactUs", path: "/ContactUs" },
  signin: { name: "Login", path: "/Signin/:id?" },
  signup: { name: "Register", path: "/Signup/:id?" },
  oauthcallback: { name: "OAuth", path: "/oauth/callback" },
  forgotPwd: { name: "ForgotPwd", path: "/ForgotPassword" },
  resetPwd: { name: "ResetPassword", path: "/ResetPassword/:id?" },
  properties: { name: "Properties", path: "/Properties" },
  property: { name: "Property", path: "/Property/:id" },
  agents: { name: "Agents", path: "/Agents" },
  agent: { name: "Agent", path: "/Agent/:id" },
  business: { name: "Business", path: "/Business/:id" },
  listedbusiness: { name: "ListedBusiness", path: "/ListedBusiness" },
  owner: { name: "Agent", path: "/Owner/:id" },
  dashboard: { name: "Dashboard", path: "/User/Dashboard" },
  checkout: {
    name: "Checkout",
    path: "/Checkout/:id",
  },
  createprofile: {
    name: "CreateProfile",
    path: "/User/CreateProfile/:profiletype?",
  },
  ownerprofile: {
    name: "OwnerProfile",
    path: "/User/Owner-Profile",
  },
  ownerprofileedit: {
    name: "OwnerProfileEdit",
    path: "/User/Owner-Profile-Edit",
  },
  notifications: {
    name: "Notifications",
    path: "/User/Notifications",
  },
  viewnotification: {
    name: "ViewNotification",
    path: "/User/ViewNotification",
  },
  profiles: { name: "Profiles", path: "/User/Profiles" },
  agentservices: {
    name: "AgentServices",
    path: "/User/Profiles/ServicesSelection",
  },
  contactinfo: {
    name: "ContactInformation",
    path: "/User/Profiles/ContactInfo",
  },
  // Profileinfo: {
  //   name: "ReviewProfileInfo",
  //   path: "/User/Profiles/ProfileInfo"
  // },
  settings: { name: "Settings", path: "/User/Settings" },
  profilesettings: {
    name: "ProfileSettings",
    path: "/User/Settings/ProfileSettings",
  },
  profileinfo: {
    name: "ProfileInfo",
    path: "/User/Settings/Profile",
  },
  accountsettings: {
    name: "AccountSettings",
    path: "/User/AccountSettings",
  },
  securitypin: {
    name: "SecurityPin",
    path: "/User/Settings/SecurityPin",
  },
  changepassword: {
    name: "ChangePassword",
    path: "/User/Settings/ChangePassword",
  },
  notificationsettings: {
    name: "NotificationSettings",
    path: "/User/Settings/Notifications",
  },
  branding: { name: "Branding", path: "/User/Settings/Branding" },
  brandingmanagement: {
    name: "BrandingManagement",
    path: "/User/Settings/BrandingManagement",
  },
  businesses: { name: "Businesses", path: "/User/Business" },
  viewbusiness: {
    name: "ViewBusiness",
    path: "/User/Business/View",
  },
  businessdetails: {
    name: "BusinessDetails",
    path: "/User/Business/BusinessDetails",
  },
  // In your routes configuration file
  editbusiness: {
    name: "EditBusiness",
    path: "/User/Business/Edit", // Add parameter
  },
  editprofilebusiness: {
    name: "EditProfileBusiness",
    path: "/User/Business/EditBusiness",
  },
  addbusiness: { name: "AddBusiness", path: "/User/Business/AddBusiness" },
  businessmembers: { name: "BusinessMembers", path: "/User/Business/Members" },
  businessaddmember: {
    name: "BusinessAddMember",
    path: "/User/Business/AddMember",
  },
  businesseditmember: {
    name: "BusinessEditMember",
    path: "/User/Business/EditMember",
  },
  businessviewmember: {
    name: "BusinessViewMember",
    path: "/User/Business/ViewMember",
  },
  listbusiness: {
    name: "ListBusiness",
    path: "/User/Business/ListBusiness",
  },
  reviewprofile: {
    name: "ReviewProfile",
    path: "/User/Business/ReviewProfile",
  },
  // addmembers:{
  //   name: "AddMembers",
  //   path: "/User/Profile/AddMembers",
  // },
  // tree: {
  //   name: "Tree",
  //   path: "/components/TreeView/Tree",
  // },
  upgradeplan: { name: "UpgradePlan", path: "/User/UpgradePlan" },
  ownerviewproperty: {
    name: "OwnerViewProperty",
    path: "/User/Owners/ViewProperty",
  },
  addresidentialproperty: {
    name: "AddResidentialProperty",
    path: "/User/Owners/AddResidentialProperty",
  },
  manageresidentialproperty: {
    name: "ManageResidentialProperty",
    path: "/User/Owners/ManageResidentialProperty",
  },
  addcommercialproperty: {
    name: "AddCommercialProperty",
    path: "/User/Owners/AddCommercialProperty",
  },
  managecommercialproperty: {
    name: "ManageCommercialProperty",
    path: "/User/Owners/ManageCommercialProperty",
  },
  ownerassignproperty: {
    name: "ManageAssignProperty",
    path: "/User/Owners/AssignProperty",
  },
  agentproperties: {
    name: "AgentProperties",
    path: "/User/Agents/Properties",
  },
  agentviewproperty: {
    name: "AgentViewProperty",
    path: "/User/Agents/ViewProperty",
  },
  agentassignedproperties: {
    name: "AgentAssignedProperties",
    path: "/User/Agents/AssignedProperties",
  },
  manageagentresidentialproperty: {
    name: "ManageAgentResidentialProperty",
    path: "/User/Agents/ManageResidentialProperty",
  },
  manageagentcommercialproperty: {
    name: "ManageAgentCommercialProperty",
    path: "/User/Agents/ManageCommercialProperty",
  },
  tenantconnectedproperties: {
    name: "TenantConnectedProperties",
    path: "/User/Tenants/ConnectedProperties",
  },
  tenantviewproperty: {
    name: "TenantViewProperty",
    path: "/User/Tenants/ViewProperty",
  },
  paymentsaccounts: {
    name: "PaymentsAccounts",
    path: "/User/Payments/Accounts",
  },
  paymentscreateaccount: {
    name: "PaymentsCreateAccount",
    path: "/User/Payments/CreateAccount",
  },
  paymentsaccountagreement: {
    name: "PaymentsAccountAgreement",
    path: "/User/Payments/AccountAgreement",
  },
  paymentsstripereturn: {
    name: "PaymentsStripeReturn",
    path: "/User/Payments/StripeReturn",
  },
  paymentsstriperefresh: {
    name: "PaymentsStripeRefresh",
    path: "/User/Payments/StripeRefresh",
  },
  paymentsinvoices: {
    name: "PaymentsInvoices",
    path: "/User/Payments/Invoices",
  },
  invoiceitems: {
    name: "InvoiceItems",
    path: "/User/Payments/InvoiceItems",
  },
  sendinvoice: {
    name: "SendInvoice",
    path: "/User/Payments/SendInvoice",
  },
  markaspaid: {
    name: "MarkAsPaid",
    path: "/User/Payments/MarkAsPaid",
  },
  createinvoiceitem: {
    name: "CreateInvoiceItem",
    path: "/User/Payments/CreateInvoiceItem",
  },
  viewinvoiceitem: {
    name: "ViewInvoiceItem",
    path: "/User/Payments/ViewInvoiceItem",
  },
  createinvoice: {
    name: "CreateInvoice",
    path: "/User/Payments/CreateInvoice",
  },
  previewinvoice: {
    name: "PreviewInvoice",
    path: "/User/Payments/PreviewInvoice",
  },
  viewinvoice: {
    name: "ViewInvoice",
    path: "/User/Payments/ViewInvoice",
  },
  editinvoice: {
    name: "EditInvoice",
    path: "/User/Payments/EditInvoice",
  },
  usercheckout: {
    name: "UserCheckout",
    path: "/User/Payments/Checkout",
  },
  paymenttype: {
    name: "PaymentType",
    path: "/User/Payments/PaymentType",
  },
  connections: {
    name: "Connections",
    path: "/User/Connections",
  },
  connectionsowners: {
    name: "ConnectionsOwners",
    path: "/User/Connections/Owners",
  },
  connectionsagents: {
    name: "ConnectionsAgents",
    path: "/User/Connections/Agents",
  },
  connectionstenants: {
    name: "ConnectionsTenants",
    path: "/User/Connections/Tenants",
  },
  connectionssendinvite: {
    name: "ConnectionsSendInvite",
    path: "/User/Connections/SendInvite",
  },
  connectionssendmessage: {
    name: "ConnectionsSendMessage",
    path: "/User/Connections/SendMessage",
  },
  editconnection: {
    name: "EditConnection",
    path: "/User/Connections/EditConnection",
  },
  agentmyproperties: {
    name: "agentmyproperties",
    path: "/User/Agents/MyProperties",
  },
  agentassignedproperties: {
    name: "agentassignedproperties",
    path: "/User/Agents/AssignedProperties",
  },
  tenantproperties: {
    name: "tenantproperties",
    path: "/User/Tenants/Properties",
  },
  tenantconnectedproperties: {
    name: "tenantconnectedproperties",
    path: "/User/Tenants/ConnectedProperties",
  },
  ownersmyproperties: {
    name: "ownersmyproperties",
    path: "/User/Owners/MyProperties",
  },
  addnewproperty: {
    name: "addnewproperty",
    path: "/User/Owners/AddNewProperty",
  },
  listedproperties: {
    name: "listedproperties",
    path: "/User/Owners/ListedProperties",
  },
  partnershipproperties: {
    name: "partnershipproperties",
    path: "/User/Owners/PartnershipProperties",
  },
  listproperty: {
    name: "ListProperty",
    path: "/User/Properties/ListProperty",
  },
  tenantprofile: {
    name: "TenantProfile",
    path: "/User/Tenant-Profile",
  },
  tenantprofileedit: {
    name: "TenantProfileEdit",
    path: "/User/Tenant-Profile-Edit",
  },
  agentprofile: {
    name: "AgentProfile",
    path: "/User/Agent-Profile",
  },
  agentprofileedit: {
    name: "AgentProfileEdit",
    path: "/User/Agent-Profile-Edit",
  },
  myagreements: {
    name: "MyAgreements",
    path: "/User/Agreements/MyAgreements",
  },
  myagreementssent: {
    name: "MyAgreementsSent",
    path: "/User/Agreements/MyAgreements/Sent",
  },
  myagreementsreceived: {
    name: "MyAgreementsReceived",
    path: "/User/Agreements/MyAgreements/Received",
  },
  myagreementsexecuted: {
    name: "MyAgreementsExecuted",
    path: "/User/Agreements/MyAgreements/Executed",
  },
  // Public agreement deeplink entry; the page handles public view vs private routing.
  publicagreementfileviewer: {
    name: "PublicAgreementFileViewer",
    path: "/agreements/file/:id",
  },
  templatestore: {
    name: "TemplateStore",
    path: "/User/Agreements/TemplateStore",
  },
  sendagreement: {
    name: "SendAgreement",
    path: "/User/Agreements/SendAgreement",
  },
  previewagreement: {
    name: "PreviewAgreement",
    path: "/User/Agreements/PreviewAgreement",
  },
  createagreement: {
    name: "CreateAgreement",
    path: "/User/Agreements/CreateAgreement",
  },
  manageagreementaccess: {
    name: "ManageAgreementAccess",
    path: "/User/Agreements/ManageAccess",
  },
  mytemplates: {
    name: "MyTemplates",
    path: "/User/Agreements/MyTemplates",
  },
  createtemplate: {
    name: "CreateTemplate",
    path: "/User/Agreements/CreateTemplate",
  },
  mydocuments: {
    name: "MyDocuments",
    path: "/User/Documents/MyDocuments",
  },
  viewdocument: {
    name: "ViewDocument",
    path: "/User/Documents/ViewDocument",
  },
  managedocumentaccess: {
    name: "ManageDocumentAccess",
    path: "/User/Documents/ManageAccess",
  },
  sharedocument: {
    name: "ShareDocument",
    path: "/User/Documents/ShareDocument",
  },
  shareddocuments: {
    name: "SharedDocuments",
    path: "/User/Documents/SharedDocuments",
  },
  sharedfolders: {
    name: "SharedFolders",
    path: "/User/Documents/SharedFolders",
  },
  sharedusers: {
    name: "SharedUsers",
    path: "/User/Documents/SharedUsers",
  },
  reportsettings: {
    name: "ReportSettings",
    path: "/User/Reports",
  },
  accounttransactions: {
    name: "AccountTransaction",
    path: "/User/Reports/AccountTransactions",
  },
  invoicestransactions: {
    name: "InvoicesTransactions",
    path: "/User/Reports/InvoicesTransactions",
  },
  invoicetransactions: {
    name: "InvoiceTransactions",
    path: "/User/Reports/InvoiceTransactions",
  },
  propertiestransactions: {
    name: "PropertiesTransaction",
    path: "/User/Reports/PropertiesTransactions",
  },
  propertytransactions: {
    name: "PropertyTransactions",
    path: "/User/Reports/PropertyTransactions",
  },
  services: { name: "Services", path: "/User/Services" },
  assignservices: {
    name: "AssignServices",
    path: "/User/Services/AssignServices",
  },
  servicesinfo: {
    name: "ServicesInfo",
    path: "/User/Services/ServicesInfo",
  },
  createservicerequest: {
    name: "CreateServiceRequest",
    path: "/User/Services/CreateRequest",
  },
  sendservicerequest: {
    name: "SendServiceRequest",
    path: "/User/Services/SendServiceRequest",
  },
  editservice: {
    name: "EditService",
    path: "/User/Service/EditService",
  },
  assignrequest: {
    name: "AssignRequest",
    path: "/User/Services/AssignRequest",
  },
  assignservicedetails: {
    name: "AssignServiceDetails",
    path: "/User/Services/AssignServiceDetails",
  },
  servicedetails: {
    name: "ServiceDetails",
    path: "/User/Services/ServiceDetails",
  },
  applications: { name: "Applications", path: "/User/Applications" },
  applicationform: {
    name: "Application",
    path: "/User/Applications/Form",
  },
  viewapplication: {
    name: "ViewApplication",
    path: "/User/Applications/ViewApplication",
  },
  viewapplicationform: {
    name: "ViewApplicationForm",
    path: "/User/Applications/ViewApplicationForm",
  },
  createapplication: {
    name: "CreateApplication",
    path: "/User/Applications/CreateApplication",
  },
  sendapplication: {
    name: "SendApplication",
    path: "/User/Applications/SendApplication",
  },
  mobiledocfileviewer: {
    name: "MobileDocFileViewer",
    path: "/m/Documents/File/:id",
  },
  mobileinvoicepdfviewer: {
    name: "MobileInvoicePdfViewer",
    path: "/m/Invoices/InvoicePdf/:id",
  },
  publicdocfileviewer: {
    name: "PublicDocFileViewer",
    path: "/Documents/File/:id",
  },
  publicdocfolderviewer: {
    name: "PublicDocFolderViewer",
    path: "/Documents/Folders/:id",
  },
  notFound: { name: "NotFound", path: "/*" },
};

const routes = [
  {
    path: routeNames.home.path,
    name: routeNames.home.name,
    element: lazy(() => import("../pages/Home")),
    isexact: true,
  },
  {
    path: routeNames.index.path,
    name: routeNames.index.name,
    element: lazy(() => import("../pages/Home")),
    isexact: true,
  },
  {
    path: routeNames.aboutUs.path,
    name: routeNames.aboutUs.name,
    element: lazy(() => import("../pages/AboutUs")),
    isexact: true,
  },
  {
    path: routeNames.howItWorks.path,
    name: routeNames.howItWorks.name,
    element: lazy(() => import("../pages/HowItWorks")),
    isexact: true,
  },
  {
    path: routeNames.privacyPolicy.path,
    name: routeNames.privacyPolicy.name,
    element: lazy(() => import("../pages/PrivacyPolicy")),
    isexact: true,
  },
  {
    path: routeNames.terms.path,
    name: routeNames.terms.name,
    element: lazy(() => import("../pages/Terms")),
    isexact: true,
  },
  {
    path: routeNames.plans.path,
    name: routeNames.plans.name,
    element: lazy(() => import("../pages/Plans")),
    isexact: true,
  },
  {
    path: routeNames.blog.path,
    name: routeNames.blog.name,
    element: lazy(() => import("../pages/Blog")),
    isexact: true,
  },
  {
    path: routeNames.partners.path,
    name: routeNames.partners.name,
    element: lazy(() => import("../pages/Partners")),
    isexact: true,
  },
  {
    path: routeNames.testimonials.path,
    name: routeNames.testimonials.name,
    element: lazy(() => import("../pages/Testimonials")),
    isexact: true,
  },
  {
    path: routeNames.createTestimonial.path,
    name: routeNames.createTestimonial.name,
    element: lazy(() => import("../pages/CreateTestimonial")),
    isexact: true,
  },
  {
    path: routeNames.contactUs.path,
    name: routeNames.contactUs.name,
    element: lazy(() => import("../pages/ContactUs")),
    isexact: true,
  },
  {
    path: routeNames.signin.path,
    name: routeNames.signin.name,
    element: lazy(() => import("../pages/Account/Signin")),
    isexact: true,
  },
  {
    path: routeNames.signup.path,
    name: routeNames.signup.name,
    element: lazy(() => import("../pages/Account/Signup")),
    isexact: true,
  },
  {
    path: routeNames.oauthcallback.path,
    name: routeNames.oauthcallback.name,
    element: lazy(() => import("../oauth/OAuthCallBack")),
    isexact: true,
  },
  {
    path: routeNames.forgotPwd.path,
    name: routeNames.forgotPwd.name,
    element: lazy(() => import("../pages/Account/ForgotPassword")),
    isexact: true,
  },
  {
    path: routeNames.resetPwd.path,
    name: routeNames.resetPwd.name,
    element: lazy(() => import("../pages/Account/ResetPassword")),
    isexact: true,
  },
  {
    path: routeNames.properties.path,
    name: routeNames.properties.name,
    element: lazy(() => import("../pages/Properties")),
    isexact: true,
  },
  {
    path: routeNames.property.path,
    name: routeNames.property.name,
    element: lazy(() => import("../pages/Property")),
    isexact: true,
  },
  {
    path: routeNames.agents.path,
    name: routeNames.agents.name,
    element: lazy(() => import("../pages/Agents")),
    isexact: true,
  },
  {
    path: routeNames.agent.path,
    name: routeNames.agent.name,
    element: lazy(() => import("../pages/Agent")),
    isexact: true,
  },
  {
    path: routeNames.business.path,
    name: routeNames.business.name,
    element: lazy(() => import("../pages/Business")),
    isexact: true,
  },
  {
    path: routeNames.listedbusiness.path,
    name: routeNames.listedbusiness.name,
    element: lazy(() => import("../pages/ListedBusiness")),
    isexact: true,
  },
  {
    path: routeNames.owner.path,
    name: routeNames.owner.name,
    element: lazy(() => import("../pages/Owner")),
    isexact: true,
  },
  {
    path: routeNames.checkout.path,
    name: routeNames.checkout.name,
    element: lazy(() => import("../pages/Checkout")),
    isexact: true,
  },
  {
    path: routeNames.dashboard.path,
    name: routeNames.dashboard.name,
    element: lazy(() => import("../pages/User/Dashboard")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createprofile.path,
    name: routeNames.createprofile.name,
    element: lazy(() => import("../pages/User/Profile/CreateProfile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.profiles.path,
    name: routeNames.profiles.name,
    element: lazy(() => import("../pages/User/Profiles")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentservices.path,
    name: routeNames.agentservices.name,
    element: lazy(() => import("../pages/User/AgentServices")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.contactinfo.path,
    name: routeNames.contactinfo.name,
    element: lazy(() => import("../pages/User/Profile/ContactInformation")),
    isexact: true,
    isprotected: true,
  },
  // {
  //   path: routeNames.profileinfo.path,
  //   name: routeNames.profileinfo.name,
  //   element: lazy(() => import("../pages/User/Profile/ReviewProfileInfo")),
  //   isexact: true,
  //   isprotected: true,
  // },
  {
    path: routeNames.settings.path,
    name: routeNames.settings.name,
    element: lazy(() => import("../pages/User/Settings/Settings")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.profilesettings.path,
    name: routeNames.profilesettings.name,
    element: lazy(() => import("../pages/User/Settings/ProfileSettings")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.profileinfo.path,
    name: routeNames.profileinfo.name,
    element: lazy(() => import("../pages/User/Settings/Profile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.accountsettings.path,
    name: routeNames.accountsettings.name,
    element: lazy(() => import("../pages/User/Settings/AccountSettings")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.securitypin.path,
    name: routeNames.securitypin.name,
    element: lazy(() => import("../pages/User/Settings/SecurityPin")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.changepassword.path,
    name: routeNames.changepassword.name,
    element: lazy(() => import("../pages/User/Settings/ChangePassword")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.notificationsettings.path,
    name: routeNames.notificationsettings.name,
    element: lazy(() => import("../pages/User/Settings/Notifications")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.branding.path,
    name: routeNames.branding.name,
    element: lazy(() => import("../pages/User/Settings/Branding")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.brandingmanagement.path,
    name: routeNames.brandingmanagement.name,
    element: lazy(() => import("../pages/User/Settings/BrandingManagement")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businesses.path,
    name: routeNames.businesses.name,
    element: lazy(() => import("../pages/User/Business/Businesses")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewbusiness.path,
    name: routeNames.viewbusiness.name,
    element: lazy(() => import("../pages/User/Business/ViewBusiness")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businessdetails.path,
    name: routeNames.businessdetails.name,
    element: lazy(() => import("../pages/User/Business/BusinessDetails")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.editbusiness.path,
    name: routeNames.editbusiness.name,
    element: lazy(() => import("../pages/User/Business/EditBusiness")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.editprofilebusiness.path,
    name: routeNames.editprofilebusiness.name,
    element: lazy(() => import("../pages/User/Business/EditProfileBusiness")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.addbusiness.path,
    name: routeNames.addbusiness.name,
    element: lazy(() => import("../pages/User/Business/AddBusiness")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businessmembers.path,
    name: routeNames.businessmembers.name,
    element: lazy(() => import("../pages/User/Business/Members")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businessaddmember.path,
    name: routeNames.businessaddmember.name,
    element: lazy(() => import("../pages/User/Business/AddMember")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businesseditmember.path,
    name: routeNames.businesseditmember.name,
    element: lazy(() => import("../pages/User/Business/EditMember")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.businessviewmember.path,
    name: routeNames.businessviewmember.name,
    element: lazy(() => import("../pages/User/Business/ViewMembers")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.listbusiness.path,
    name: routeNames.listbusiness.name,
    element: lazy(() => import("../pages/User/Business/ListBusiness")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.reviewprofile.path,
    name: routeNames.reviewprofile.name,
    element: lazy(() => import("../pages/User/Business/ReviewProfile")),
    isexact: true,
    isprotected: true,
  },
  // {
  //   path: routeNames.addmembers.path,
  //   name: routeNames.addmembers.name,
  //   element: lazy(() => import("../pages/User/Profile/AddMembers")),
  //   isexact: true,
  //   isprotected: true,
  // },
  // {
  //   path: routeNames.tree.path,
  //   name: routeNames.tree.name,
  //   element: lazy(() => import("../components/TreeView/Tree")),
  //   isexact: true,
  //   isprotected: true,
  // },
  {
    path: routeNames.upgradeplan.path,
    name: routeNames.upgradeplan.name,
    element: lazy(() => import("../pages/User/UpgradePlan")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.ownerviewproperty.path,
    name: routeNames.ownerviewproperty.name,
    element: lazy(() => import("../pages/User/Properties/Owners/ViewProperty")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.addresidentialproperty.path,
    name: routeNames.addresidentialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/AddResidentialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.manageresidentialproperty.path,
    name: routeNames.manageresidentialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/ManageResidentialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.addcommercialproperty.path,
    name: routeNames.addcommercialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/AddCommercialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.managecommercialproperty.path,
    name: routeNames.managecommercialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/ManageCommercialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.ownerassignproperty.path,
    name: routeNames.ownerassignproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/AssignProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentviewproperty.path,
    name: routeNames.agentviewproperty.name,
    element: lazy(() => import("../pages/User/Properties/Agents/ViewProperty")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.manageagentresidentialproperty.path,
    name: routeNames.manageagentresidentialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Agents/ManageResidentialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.manageagentcommercialproperty.path,
    name: routeNames.manageagentcommercialproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Agents/ManageCommercialProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.tenantviewproperty.path,
    name: routeNames.tenantviewproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Tenants/ViewProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentsaccounts.path,
    name: routeNames.paymentsaccounts.name,
    element: lazy(() => import("../pages/User/Payments/Accounts")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentscreateaccount.path,
    name: routeNames.paymentscreateaccount.name,
    element: lazy(() => import("../pages/User/Payments/CreateAccount")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentsaccountagreement.path,
    name: routeNames.paymentsaccountagreement.name,
    element: lazy(() => import("../pages/User/Payments/AccountAgreement")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentsstripereturn.path,
    name: routeNames.paymentsstripereturn.name,
    element: lazy(() => import("../pages/User/Payments/StripeReturn")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentsstriperefresh.path,
    name: routeNames.paymentsstriperefresh.name,
    element: lazy(() => import("../pages/User/Payments/StripeRefresh")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.invoiceitems.path,
    name: routeNames.invoiceitems.name,
    element: lazy(() => import("../pages/User/Payments/InvoiceItems")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createinvoiceitem.path,
    name: routeNames.createinvoiceitem.name,
    element: lazy(() => import("../pages/User/Payments/CreateInvoiceItem")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewinvoiceitem.path,
    name: routeNames.viewinvoiceitem.name,
    element: lazy(() => import("../pages/User/Payments/ViewInvoiceItem")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymentsinvoices.path,
    name: routeNames.paymentsinvoices.name,
    element: lazy(() => import("../pages/User/Payments/Invoices")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createinvoice.path,
    name: routeNames.createinvoice.name,
    element: lazy(() => import("../pages/User/Payments/CreateInvoice")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.previewinvoice.path,
    name: routeNames.previewinvoice.name,
    element: lazy(() => import("../pages/User/Payments/PreviewInvoice")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewinvoice.path,
    name: routeNames.viewinvoice.name,
    element: lazy(() => import("../pages/User/Payments/ViewInvoice")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.editinvoice.path,
    name: routeNames.editinvoice.name,
    element: lazy(() => import("../pages/User/Payments/EditInvoice")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sendinvoice.path,
    name: routeNames.sendinvoice.name,
    element: lazy(() => import("../pages/User/Payments/SendInvoice")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.markaspaid.path,
    name: routeNames.markaspaid.name,
    element: lazy(() => import("../pages/User/Payments/MarkAsPaid")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.usercheckout.path,
    name: routeNames.usercheckout.name,
    element: lazy(() => import("../pages/User/Payments/Checkout")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.paymenttype.path,
    name: routeNames.paymenttype.name,
    element: lazy(() => import("../pages/User/Payments/PaymentType")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connections.path,
    name: routeNames.connections.name,
    element: lazy(() => import("../pages/User/Connections/Connections")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connectionsowners.path,
    name: routeNames.connectionsowners.name,
    element: lazy(() => import("../pages/User/Connections/Owners")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connectionsagents.path,
    name: routeNames.connectionsagents.name,
    element: lazy(() => import("../pages/User/Connections/Agents")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connectionstenants.path,
    name: routeNames.connectionstenants.name,
    element: lazy(() => import("../pages/User/Connections/Tenants")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connectionssendinvite.path,
    name: routeNames.connectionssendinvite.name,
    element: lazy(() => import("../pages/User/Connections/SendInvite")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.connectionssendmessage.path,
    name: routeNames.connectionssendmessage.name,
    element: lazy(() => import("../pages/User/Connections/SendMessage")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.editconnection.path,
    name: routeNames.editconnection.name,
    element: lazy(() => import("../pages/User/Connections/EditConnection")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentmyproperties.path,
    name: routeNames.agentmyproperties.name,
    element: lazy(() => import("../pages/User/Properties/Agents/MyProperties")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentassignedproperties.path,
    name: routeNames.agentassignedproperties.name,
    element: lazy(
      () => import("../pages/User/Properties/Agents/AssignedProperties"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.tenantproperties.path,
    name: routeNames.tenantproperties.name,
    element: lazy(() => import("../pages/User/Properties/Tenants/Properties")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.tenantconnectedproperties.path,
    name: routeNames.tenantconnectedproperties.name,
    element: lazy(
      () => import("../pages/User/Properties/Tenants/ConnectedProperties"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.ownersmyproperties.path,
    name: routeNames.ownersmyproperties.name,
    element: lazy(() => import("../pages/User/Properties/Owners/MyProperties")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.addnewproperty.path,
    name: routeNames.addnewproperty.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/AddNewProperty"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.listedproperties.path,
    name: routeNames.listedproperties.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/ListedProperties"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.partnershipproperties.path,
    name: routeNames.partnershipproperties.name,
    element: lazy(
      () => import("../pages/User/Properties/Owners/PartnershipProperties"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.listproperty.path,
    name: routeNames.listproperty.name,
    element: lazy(() => import("../pages/User/Properties/Owners/ListProperty")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.ownerprofile.path,
    name: routeNames.ownerprofile.name,
    element: lazy(() => import("../pages/User/Owners/Profile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.ownerprofileedit.path,
    name: routeNames.ownerprofileedit.name,
    element: lazy(() => import("../pages/User/Owners/EditProfile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.notifications.path,
    name: routeNames.notifications.name,
    element: lazy(() => import("../pages/User/Notifications/Notifications")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewnotification.path,
    name: routeNames.viewnotification.name,
    element: lazy(() => import("../pages/User/Notifications/ViewNotification")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.tenantprofile.path,
    name: routeNames.tenantprofile.name,
    element: lazy(() => import("../pages/User/Tenants/Profile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.tenantprofileedit.path,
    name: routeNames.tenantprofileedit.name,
    element: lazy(() => import("../pages/User/Tenants/EditProfile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentprofile.path,
    name: routeNames.agentprofile.name,
    element: lazy(() => import("../pages/User/Agents/Profile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.agentprofileedit.path,
    name: routeNames.agentprofileedit.name,
    element: lazy(() => import("../pages/User/Agents/EditProfile")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.myagreements.path,
    name: routeNames.myagreements.name,
    element: lazy(() => import("../pages/User/Agreements/MyAgreements")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.myagreementssent.path,
    name: routeNames.myagreementssent.name,
    element: lazy(() => import("../pages/User/Agreements/SentAgreements")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.myagreementsreceived.path,
    name: routeNames.myagreementsreceived.name,
    element: lazy(() => import("../pages/User/Agreements/ReceivedAgreements")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.myagreementsexecuted.path,
    name: routeNames.myagreementsexecuted.name,
    element: lazy(() => import("../pages/User/Agreements/ExecutedAgreements")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.templatestore.path,
    name: routeNames.templatestore.name,
    element: lazy(() => import("../pages/User/Agreements/TemplateStore.jsx")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sendagreement.path,
    name: routeNames.sendagreement.name,
    element: lazy(() => import("../pages/User/Agreements/SendAgreement")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.previewagreement.path,
    name: routeNames.previewagreement.name,
    element: lazy(() => import("../pages/User/Agreements/PreviewAgreement")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createagreement.path,
    name: routeNames.createagreement.name,
    element: lazy(() => import("../pages/User/Agreements/CreateAgreement.jsx")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.manageagreementaccess.path,
    name: routeNames.manageagreementaccess.name,
    element: lazy(() => import("../pages/User/Agreements/ManageAccess.jsx")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.mytemplates.path,
    name: routeNames.mytemplates.name,
    element: lazy(() => import("../pages/User/Agreements/MyTemplates.jsx")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createtemplate.path,
    name: routeNames.createtemplate.name,
    element: lazy(() => import("../pages/User/Agreements/CreateTemplate.jsx")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.mydocuments.path,
    name: routeNames.mydocuments.name,
    element: lazy(() => import("../pages/User/Documents/MyDocuments")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewdocument.path,
    name: routeNames.viewdocument.name,
    element: lazy(() => import("../pages/User/Documents/ViewDocument")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.managedocumentaccess.path,
    name: routeNames.managedocumentaccess.name,
    element: lazy(() => import("../pages/User/Documents/ManageAccess")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sharedocument.path,
    name: routeNames.sharedocument.name,
    element: lazy(() => import("../pages/User/Documents/ShareDocument")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.shareddocuments.path,
    name: routeNames.shareddocuments.name,
    element: lazy(() => import("../pages/User/Documents/SharedDocuments")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sharedfolders.path,
    name: routeNames.sharedfolders.name,
    element: lazy(() => import("../pages/User/Documents/SharedFolders")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sharedusers.path,
    name: routeNames.sharedusers.name,
    element: lazy(() => import("../pages/User/Documents/SharedUsers")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.reportsettings.path,
    name: routeNames.reportsettings.name,
    element: lazy(() => import("../pages/User/Reports/Reports")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.accounttransactions.path,
    name: routeNames.accounttransactions.name,
    element: lazy(() => import("../pages/User/Reports/AccountTransactions")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.invoicestransactions.path,
    name: routeNames.invoicestransactions.name,
    element: lazy(() => import("../pages/User/Reports/InvoicesTransactions")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.invoicetransactions.path,
    name: routeNames.invoicetransactions.name,
    element: lazy(() => import("../pages/User/Reports/InvoiceTransactions")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.propertiestransactions.path,
    name: routeNames.propertiestransactions.name,
    element: lazy(() => import("../pages/User/Reports/PropertiesTransactions")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.propertytransactions.path,
    name: routeNames.propertytransactions.name,
    element: lazy(
      () => import("../pages/User/Reports/PropertyTransactions.jsx"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.services.path,
    name: routeNames.services.name,
    element: lazy(() => import("../pages/User/Services/Services")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.assignservices.path,
    name: routeNames.assignservices.name,
    element: lazy(() => import("../pages/User/Services/AssignServices")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.servicesinfo.path,
    name: routeNames.servicesinfo.name,
    element: lazy(() => import("../pages/User/Services/ServicesInfo")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createservicerequest.path,
    name: routeNames.createservicerequest.name,
    element: lazy(() => import("../pages/User/Services/CreateRequest")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sendservicerequest.path,
    name: routeNames.sendservicerequest.name,
    element: lazy(() => import("../pages/User/Services/SendRequest")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.editservice.path,
    name: routeNames.editservice.name,
    element: lazy(() => import("../pages/User/Services/EditService")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.assignrequest.path,
    name: routeNames.assignrequest.name,
    element: lazy(() => import("../pages/User/Services/AssignRequest")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.assignservicedetails.path,
    name: routeNames.assignservicedetails.name,
    element: lazy(() => import("../pages/User/Services/AssignServiceDetails")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.servicedetails.path,
    name: routeNames.servicedetails.name,
    element: lazy(() => import("../pages/User/Services/ServiceDetails")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.applications.path,
    name: routeNames.applications.name,
    element: lazy(() => import("../pages/User/Applications/Applications")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.applicationform.path,
    name: routeNames.applicationform.name,
    element: lazy(() => import("../pages/User/Applications/ApplicationForm")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewapplication.path,
    name: routeNames.viewapplication.name,
    element: lazy(() => import("../pages/User/Applications/ViewApplication")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.viewapplicationform.path,
    name: routeNames.viewapplicationform.name,
    element: lazy(
      () => import("../pages/User/Applications/ViewApplicationForm"),
    ),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.createapplication.path,
    name: routeNames.createapplication.name,
    element: lazy(() => import("../pages/User/Applications/CreateApplication")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.sendapplication.path,
    name: routeNames.sendapplication.name,
    element: lazy(() => import("../pages/User/Applications/SendApplication")),
    isexact: true,
    isprotected: true,
  },
  {
    path: routeNames.mobiledocfileviewer.path,
    name: routeNames.mobiledocfileviewer.name,
    element: lazy(() => import("../pages/Mobile/Documents/FileViewer")),
    isexact: true,
  },
  {
    path: routeNames.mobileinvoicepdfviewer.path,
    name: routeNames.mobileinvoicepdfviewer.name,
    element: lazy(() => import("../pages/Mobile/Invoices/InvoicePdfViewer")),
    isexact: true,
  },
  {
    path: routeNames.publicdocfileviewer.path,
    name: routeNames.publicdocfileviewer.name,
    element: lazy(() => import("../pages/Public/Documents/FileViewer")),
    isexact: true,
  },
  {
    path: routeNames.publicdocfolderviewer.path,
    name: routeNames.publicdocfolderviewer.name,
    element: lazy(() => import("../pages/Public/Documents/FoldersViewer")),
    isexact: true,
  },
  {
    // Public agreement file deeplink route.
    path: routeNames.publicagreementfileviewer.path,
    name: routeNames.publicagreementfileviewer.name,
    element: lazy(() => import("../pages/Public/Agreements/FileViewer")),
    isexact: true,
  },
  {
    path: routeNames.notFound.path,
    name: routeNames.notFound.name,
    element: lazy(() => import("../pages/NotFound")),
  },
];

export default routes;
